import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data/data.service';
import { LocationService } from 'src/app/services/location/location.service';
import { MapService } from 'src/app/services/map/map.service';

import { PotreeCesiumViewerService } from '../../../components/potree-cesium-viewer/potree-cesium-viewer.service';
// import { PotreeCesiumToolType } from '../../../components/potree-cesium-viewer/potree-cesium-viewer.component';

import noUiSlider from 'nouislider';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LayerStoreService } from 'src/app/stores/layer-store/layer-store.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { GalleryImagesStoreService } from 'src/app/stores/gallery-images-store/gallery-images-store.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { MapLayerService } from 'src/app/services/map-layer/map-layer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MapLayerGroupService } from 'src/app/services/map-layer-group/map-layer-group.service';
import { LS } from 'src/app/helpers/localStorage.enum';

// import * as assetsGeojson from 'src/assets/geojsons/Asset_WGS.json'
// import * as boundariesGeojson from 'src/assets/geojsons/Boundary_WGS.json'
// import * as buildingsGeojson from 'src/assets/geojsons/Building_WGS.json'
// import * as openAreaGeojson from 'src/assets/geojsons/Open Area_WGS.json'

declare var $;

@Component({
  selector: 'app-layer-list',
  templateUrl: './layer-list.component.html',
  styleUrls: ['./layer-list.component.sass'],
})
export class LayerListComponent implements OnInit, OnDestroy, AfterViewInit {
  isOrtho;
  isThreeD;
  isGrid;
  isThreeDMesh;
  isEmbed;
  isGeojson;
  isDSM;
  isThermal;
  isSatellite;
  isAnnotation;
  isGalleryImages;
  hasGalleryImages;
  currLocation;
  rateControl: FormControl;
  // isLarsenToubro = false;
  // isAsset = false
  // isBoundary = false
  // isBuilding = false
  // isOpenArea = false
  isFacade;
  isEditGeojson = false;

  embedLayers = [];
  embedLayerFilter = [];

  geojsonLayers = [];
  geojsonLayerFilter = [];
  orthoManyLayerFilter = [];
  toggleGeojsonTool = [];
  geojsonLayerTool_fill_color = '#FFFF00';
  geojsonLayerTool_line_color = '#FFFF00';
  geojsonLayerTool_line_width = 4;
  geojsonLayerTool_line_dasharray = '[1]';

  //  annotations;
  dataServiceAnnotSub: Subscription;
  // genericTypeKeyId = [];
  componentFilter = [];
  defectFilter = [];
  severityFilter = [];
  selectedGeojson;

  hasLoaded = false;
  splitScreenOn = false;
  annotationServiceSub: Subscription;

  unsubber: Subject<boolean> = new Subject<boolean>();

  isSplitscreenOn = false;

  isShowFormGroup = false;
  formGeojsonGroup: FormGroup;
  formGeojsonSubgroup: FormGroup;
  formGeojsonLayer: FormGroup;

  geoJsonGroup = [];
  currentUser: any;

  constructor(
    private dataService: DataService,
    public mapService: MapService,
    private potreeCesiumViewerService: PotreeCesiumViewerService,
    private layerStore: LayerStoreService,
    private locService: LocationService,
    private locationStore: LocationStoreService,
    private galleryImagesStore: GalleryImagesStoreService,
    private splitViewService: SplitViewService,
    private locationService: LocationService,
    private mapLayerService: MapLayerService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private mapLayerGroupService: MapLayerGroupService
  ) {}

  ngAfterViewInit(): void {
    this.isSplitscreenOn = this.splitViewService.isSplitscreenOn;
    // instantiate grid rotate slider with disabled attr
    setTimeout(() => {
      if ($('.slider-grid')[0]) {
        if ($('.slider-grid')[0].noUiSlider) {
          $('.slider-grid')[0].noUiSlider.destroy();
        }
        const rotateSlider = noUiSlider.create($('.slider-grid')[0], {
          start: [0],
          range: {
            min: [0],
            max: [90],
          },
          step: 2,
        });
      }
      $('.slider-grid').attr('disabled', true);
      $('.rotateInput').attr('disabled', true);
      $('.reset-grid-button').attr('disabled', true);
    }, 2000);
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    console.log(this.currentUser.roles[0], 'this.currentUser');

    this.formGeojsonGroup = this.fb.group({
      name: ['', Validators.required],
      location: ['', Validators.required],
    });
    this.formGeojsonSubgroup = this.fb.group({
      name: ['', Validators.required],
      groupId: ['', Validators.required],
    });
    this.formGeojsonLayer = this.fb.group({
      map_layer: [[], Validators.required],
    });

    this.rateControl = new FormControl(this.mapService.gridRotateAngle || 0, [
      Validators.max(90),
      Validators.min(0),
    ]);
    this.mapService.isOrtho$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.setIsOrtho = res;
        if (res) this.isOrtho = res;
      });
    this.mapService.isDSM$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.setIsDSM = this.isDSM = res;
      });
    this.mapService.isThermal$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.setIsThermal = this.isThermal = res;
      });
    this.mapService.isThreeD$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.setIsThreeD = this.isThreeD = res;
      });
    this.mapService.isGrid$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.isGrid = res;
      });
    this.mapService.isThreeDMesh$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.setIsThreeDMesh = this.isThreeDMesh = res;
      });
    this.mapService.isGalleryImages$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.isGalleryImages = res;
      });
    this.galleryImagesStore.galleryImages$.subscribe((res) => {
      if (res[0]) this.hasGalleryImages = true;
      else this.hasGalleryImages = false;
    });
    this.layerStore.isEmbed$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.isEmbed = res;
      });
    this.layerStore.isGeojson$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.isGeojson = res;
      });
    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.layerStore.resetMapLayer();
        this.currLocation = res;
        this.splitViewService.onEvent$.next({ onRemoveAllSplitScreen: true });

        if (this.currLocation.id) {
          this.mapLayerGroupService
            .findOne(this.currLocation.id)
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
            });
        }

        if (res && res.pinned_map_layer_type) {
          const getPinnedOrtho = res.pinned_map_layer_type.filter((i) =>
            i.includes('ortho')
          );
          getPinnedOrtho.forEach((i, k) => {
            let layerId = i.split('_');
            // setTimeout(() => {
            if (layerId.length > 1) {
              const ortho = res.map_layer_ortho_all.filter(
                (l) => l.id === layerId[1]
              );
              this.layerStore.toggleOrthoManyLayer(ortho[0]);
            } else {
              this.layerStore.toggleOrthoManyLayer(res.map_layer_ortho);
            }
            // }, 100 * (k + 1));
          });
          this.isOrtho = true;
        }
      });

    this.layerStore.isAnnotation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => (this.isAnnotation = arr));

    this.layerStore.isFacade$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => (this.isFacade = arr));

    this.layerStore.embedLayers$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => {
        this.embedLayers = arr;
      });
    this.layerStore.embedLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => (this.embedLayerFilter = arr));

    // this.layerStore.geojsonLayers$
    //   .pipe(takeUntil(this.unsubber.asObservable()))
    //   .subscribe((arr) => {
    //     this.geojsonLayers = arr;
    //   });
    this.layerStore.geojsonLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => {
        this.geojsonLayerFilter = arr;
      });
    this.layerStore.orthoManyLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((arr) => {
        this.orthoManyLayerFilter = arr;
      });

    this.toggleSwitch('annotations');

    this.splitViewService.onEvent$.subscribe((res) => {
      if (res.isSplitscreenOn === undefined) return;
      this.splitScreenOn = res.isSplitscreenOn;
    });
  }

  toggleMapLayer(type: string) {
    const map_layer = `map_layer_${type.replace('-', '_').toLowerCase()}`;
    this.layerStore.toggleMapLayer(
      type,
      this.currLocation.id,
      this.currLocation[map_layer]
    );

    //temporary close 3d when ortho on
    switch (type) {
      case 'ortho':
        if (this.isThreeD) {
          this.layerStore.toggleMapLayer(
            '3d',
            this.currLocation.id,
            this.currLocation[map_layer],
            false
          );
        }
        break;
      // case '3d':
      //   if (this.isOrtho) {
      //     this.layerStore.toggleMapLayer(
      //       'ortho',
      //       this.currLocation.id,
      //       this.currLocation[map_layer],
      //       false
      //     );
      //   }
      //   break;
      default:
        break;
    }
  }

  arrayHasLayerType(array, layerType) {
    if (array.find((i) => i.layer_type === layerType)) return true;
    else return false;
  }

  toggleSwitch(switch_name, value?, event?) {
    switch (switch_name) {
      case 'map_layer':
        this.toggleMapLayer(value);
        break;
      case 'satellite':
        this.layerStore.toggleSatellite();
        break;
      case 'annotations':
        this.layerStore.toggleAllAnnotationDataLayer();
        break;
      case 'grid':
        this.mapService.toggleGrid(event.target.checked);
        break;
      // case 'assets':
      //   // this.toggleLarsenToubroSwitches()
      //   this.isAsset = !this.isAsset
      //   this.isBoundary = false
      //   this.isBuilding = false
      //   this.isOpenArea = false
      //   if (this.isAsset) {
      //     this.mapService.loadGeoJsons(assetsGeojson);
      //   } else {
      //     this.mapService.removeGeoJsons();
      //   }
      //   break;
      // case 'boundaries':
      //   this.isAsset = false
      //   this.isBoundary = !this.isBoundary
      //   this.isBuilding = false
      //   this.isOpenArea = false
      //   if (this.isBoundary) {
      //     this.mapService.loadGeoJsons(boundariesGeojson);
      //   } else {
      //     this.mapService.removeGeoJsons();
      //   }
      //   break;
      // case 'buildings':
      //   this.isAsset = false
      //   this.isBoundary = false
      //   this.isBuilding = !this.isBuilding
      //   this.isOpenArea = false
      //   if (this.isBuilding) {
      //     this.mapService.loadGeoJsons(buildingsGeojson);
      //   } else {
      //     this.mapService.removeGeoJsons();
      //   }
      //   break;
      // case 'openAreas':
      //   this.isAsset = false
      //   this.isBoundary = false
      //   this.isBuilding = false
      //   this.isOpenArea = !this.isOpenArea
      //   if (this.isOpenArea) {
      //     this.mapService.loadGeoJsons(openAreaGeojson);
      //   } else {
      //     this.mapService.removeGeoJsons();
      //   }
      //   break;
    }
  }

  // toggleLarsenToubroSwitches() {
  //   this.isAsset = false
  //   this.isBoundary = false
  //   this.isBuilding = false
  //   this.isOpenArea = false
  // }

  toggleGalleryImages() {
    this.isGalleryImages = !this.isGalleryImages;

    this.mapService.toggleGalleryImages(this.isGalleryImages);
  }

  onToggleOrbitChanged(e) {
    this.potreeCesiumViewerService.orbitIsOn$.next(e.target.checked);
  }

  ngOnDestroy() {
    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  toggleAnnotationBy(category, id) {
    this.layerStore.toggleAnnotationBy({ category, id });
  }

  /** Retrieve filtered report */
  genFilteredReport() {
    const filters = {};

    this.componentFilter.map((filter) => {
      filters['location_component'] = filters['location_component'] || [];

      filters['location_component'].push(filter);
    });
    this.severityFilter.map((filter) => {
      filters['severity_type'] = filters['severity_type'] || [];

      filters['severity_type'].push(filter);
    });
    this.defectFilter.map((filter) => {
      filters['annotation_type'] = filters['annotation_type'] || [];

      filters['annotation_type'].push(filter);
    });

    this.locService.generateReport(this.currLocation.id, filters);
  }

  toggleEmbedLayer(id) {
    this.layerStore.toggleEmbedLayer(id);
  }

  toggleGeojsonLayer(id) {
    this.layerStore.toggleGeojsonLayer(id);
  }

  toggleOrthoManyLayer(ortho) {
    this.layerStore.toggleOrthoManyLayer(ortho);
  }

  toggleEditGeojson() {
    this.isEditGeojson = !this.isEditGeojson;
  }

  onRotateInputChange(e) {
    let value = parseInt(e.target.value);
    if (value < 0) {
      this.rateControl.setValue(0);
      value = 0;
    }
    if (value > 90) {
      this.rateControl.setValue(90);
      value = 90;
    }
    if (value != this.mapService.gridRotateAngle) {
      $('.slider-grid')[0].noUiSlider.set(value);
      this.mapService.gridRotateAngle = value;
    }
  }

  onResetGridClicked() {
    this.mapService.handleRequestGridReset();
  }

  onPinMapLayer(value) {
    if (!this.currLocation.pinned_map_layer_type) return;
    if (this.currLocation.pinned_map_layer_type.includes(value)) {
      for (var i = 0; i < this.currLocation.pinned_map_layer_type.length; i++) {
        if (this.currLocation.pinned_map_layer_type[i] === value) {
          this.currLocation.pinned_map_layer_type.splice(i, 1);
        }
      }
    } else {
      this.currLocation.pinned_map_layer_type = [value];
      /**
       * experimental: uncomment below for multiple pinning
       */
      // this.currLocation.pinned_map_layer_type.push(value)
    }
    this.locationService
      .setPinnedMapLayer(
        this.currLocation.id,
        this.currLocation.pinned_map_layer_type
      )
      .subscribe((res) => {
        console.log(res);
      });
    this.locationStore.setCurrentLocation = { ...this.currLocation };
  }

  toggleAllGeojsonLayer(e) {
    const { checked } = e.target;
    let layers;

    if (checked) {
      layers = this.geojsonLayers.filter(
        (i) => !this.geojsonLayerFilter.includes(i.id)
      );
      layers.forEach((l) => this.toggleGeojsonLayer(l.id));
    } else {
      layers = this.geojsonLayers.filter((i) =>
        this.geojsonLayerFilter.includes(i.id)
      );
      layers.forEach((l) => {
        this.mapService.removeGeoJsons(undefined, l.id);
      });
      this.layerStore.geojsonLayerFilter$.next([]);
      this.geojsonLayerFilter = [];
    }
  }

  toggleAllOrthoLayer(e) {
    const { checked } = e.target;
    let layers;

    if (checked) {
      layers = this.currLocation.map_layer_ortho_all.filter(
        (i) => !this.orthoManyLayerFilter.includes(i.id)
      );
      layers.forEach((l) => this.toggleOrthoManyLayer(l));
    } else {
      layers = this.currLocation.map_layer_ortho_all.filter((i) =>
        this.orthoManyLayerFilter.includes(i.id)
      );
      layers.forEach((l) => {
        this.mapService.removeOrtho(l.id);
      });
      this.layerStore.orthoManyLayerFilter$.next([]);
      this.orthoManyLayerFilter = [];
    }
  }

  async onToggleGeojsonTool(item) {
    this.selectedGeojson = item;
    // let pos = -1;

    // pos = this.toggleGeojsonTool.indexOf(id);
    // if (pos > -1) {
    //   this.toggleGeojsonTool.splice(pos, 1);
    // } else this.toggleGeojsonTool.push(id);
    const gl_layer = this.geojsonLayers.filter((gl) => gl.id === item.id);

    if (item.id && gl_layer.length > 0 && gl_layer[0].external_url) {
      const response = await fetch(gl_layer[0].external_url);
      const geojson = await response.json();

      const features = geojson.default?.features || geojson.features;
      switch (true) {
        case features[0]['geometry']['type'].toLowerCase().includes('polygon'):
          this.geojsonLayerTool_fill_color =
            features[0]['properties']['_f_color'] || '#FFFF00';
          this.geojsonLayerTool_line_color =
            features[0]['properties']['_f_o_color'] || '#FFFF00';
          this.geojsonLayerTool_line_width = undefined;
          break;
        case features[0]['geometry']['type'].toLowerCase().includes('line'):
          this.geojsonLayerTool_fill_color = undefined;
          this.geojsonLayerTool_line_color =
            features[0]['properties']['_l_color'] || '#FFFF00';
          this.geojsonLayerTool_line_width =
            features[0]['properties']['_l_width'] || 4;
          break;
        case features[0]['geometry']['type'].toLowerCase().includes('point'):
          this.geojsonLayerTool_fill_color =
            features[0]['properties']['_c_color'] || '#FFFF00';
          this.geojsonLayerTool_line_color =
            features[0]['properties']['_c_s_color'] || '#FFFF00';
          this.geojsonLayerTool_line_width =
            features[0]['properties']['_c_s_width'] || 4;
          break;
      }
      // const filteredFeatures = features.filter(
      //   (i) => i.geometry?.type === 'Polygon'
      // );
      // this.geojsonLayerTool_line_color =
      //   filteredFeatures[0]['properties']['_l_color'] || '#FFFF00';
      // this.geojsonLayerTool_line_width =
      //   filteredFeatures[0]['properties']['_l_width'] || 4;
      // this.geojsonLayerTool_line_dasharray =
      //   filteredFeatures[0]['properties']['_l_darray'] || '[1]';

      this.toggleGeojsonTool = [item.id];
      return;
    }
    this.toggleGeojsonTool = [item.id];
  }

  saveGeojsonLayerStyle(id, e) {
    this.mapLayerService.updateStyle(id, e).subscribe((res) => {
      this.toggleGeojsonTool = [0];

      let newGeojsonLayer = this.geojsonLayers.map((gl) => {
        if (gl.id === res.id) {
          return res;
        }
        return gl;
      });
      this.layerStore.geojsonLayers$.next(newGeojsonLayer);

      this.toggleGeojsonLayer(res.id);
      this.toggleGeojsonLayer(res.id);
    });
  }

  showElement(id: any, type: any) {
    const form = document.getElementById(`form-${type}-${id}`);
    form.style.display = 'block';
    const btn = document.getElementById(`btn-${type}-${id}`);
    btn.style.display = 'none';
  }

  hideElement(id: any, type: any) {
    const form = document.getElementById(`form-${type}-${id}`);
    form.style.display = 'none';
    const btn = document.getElementById(`btn-${type}-${id}`);
    btn.style.display = 'block';
  }

  resetForm() {
    this.formGeojsonGroup.reset();
    this.formGeojsonSubgroup.reset();
  }

  async onSubmitForm(
    formName: any,
    action: string,
    groupId?: any,
    subgroupId?: any
  ) {
    switch (formName) {
      case 'formGeojsonGroup':
        this.formGeojsonGroup.patchValue({
          location: this.currLocation.id,
        });
        this.spinner.show();
        if (action === 'add') {
          if (this.formGeojsonGroup.valid) {
            this.mapLayerGroupService
              .createGroup(this.formGeojsonGroup.value)
              .pipe(takeUntil(this.unsubber.asObservable()))
              .subscribe((res) => {
                this.geoJsonGroup = res.geoJsonGroup;
                this.geojsonLayers = res.currGeoMapLayer;
                this.resetForm();
                this.isShowFormGroup = false;
                this.reloadView();
                this.spinner.hide();
              });
          }
        } else if (action === 'edit') {
          this.mapLayerGroupService
            .updateGroup(groupId, this.formGeojsonGroup.value)
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
              this.resetForm();
              this.isShowFormGroup = false;
              this.reloadView();
              this.spinner.hide();
            });
        } else {
          this.mapLayerGroupService
            .removeGroup(groupId, this.currLocation.id)
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
              this.isShowFormGroup = false;
              this.reloadView();
              this.spinner.hide();
            });
        }
        break;
      case 'formGeojsonSubgroup':
        this.formGeojsonSubgroup.patchValue({
          groupId: groupId,
        });
        this.spinner.show();
        if (action === 'add') {
          if (this.formGeojsonSubgroup.valid) {
            this.mapLayerGroupService
              .createSubgroup(
                this.currLocation.id,
                this.formGeojsonSubgroup.value
              )
              .pipe(takeUntil(this.unsubber.asObservable()))
              .subscribe((res) => {
                this.geoJsonGroup = res.geoJsonGroup;
                this.geojsonLayers = res.currGeoMapLayer;
                this.isShowFormGroup = false;
                this.resetForm();
                this.reloadView();
                this.spinner.hide();
              });
          }
        } else if (action === 'edit') {
          this.mapLayerGroupService
            .updateSubgroup(
              subgroupId,
              this.currLocation.id,
              this.formGeojsonSubgroup.value
            )
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
              this.isShowFormGroup = false;
              this.resetForm();
              this.reloadView();
              this.spinner.hide();
            });
        } else if (action === 'delete') {
          this.mapLayerGroupService
            .removeSubgroup(subgroupId, this.currLocation.id)
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
              this.isShowFormGroup = false;
              this.reloadView();
              this.spinner.hide();
            });
        }

        break;
      case 'formGeojsonLayer':
        if (this.formGeojsonLayer.valid) {
          this.spinner.show();
          this.mapLayerGroupService
            .updateSubgroup(
              subgroupId,
              this.currLocation.id,
              this.formGeojsonLayer.value
            )
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.geoJsonGroup = res.geoJsonGroup;
              this.geojsonLayers = res.currGeoMapLayer;
              this.resetForm();
              this.reloadView();
              this.spinner.hide();
            });
        }
        break;
    }
  }

  reloadView() {
    setTimeout(() => {
      let toggler = document.getElementsByClassName('caret');
      for (let i = 0; i < toggler.length; i++) {
        toggler[i].addEventListener('click', function () {
          this.parentElement
            .querySelector('.nested')
            .classList.toggle('active');
          this.classList.toggle('caret-down');
        });
      }
    });
  }
}
